import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

import { authRoutes, registrationRoutes } from '@/router/appRoutes';

export const routes = {
  home: {
    path: '/',
    name: 'home',
    component: () => import('@/components/pages/HomePage.vue'),
    meta: { requireAuth: false }
  },
  designSystem: {
    path: '/systeme-de-design',
    name: 'design-system',
    component: () => import('@/components/pages/DesignSystemPage.vue'),
    meta: { requireAuth: false },
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) =>
      import.meta.env.VITE_SENTRY_ENV === 'Développement' ? next() : next('/')
  },
  ...authRoutes,
  ...registrationRoutes,
  pageNotFound: {
    path: '/:pathMatch(.*)*',
    name: 'page-not-found',
    component: () => import('@/components/pages/NotFoundPage.vue')
  }
};
